import Image from 'next/image'
import { useIntl } from 'react-intl'
import { styled } from 'styled-components'

import {
  PlayButton as BasePlayButton,
  VideoOverlay,
} from '@b-stock/fe-core/bstock-next/components'

import { getLegacyBpStaticPath } from '@/buyer-portal/buyUrlPrefix'

import type { KeyedMedia } from '../types'
import {
  Grid,
  GridCell,
  GridHoverOverlay,
  GridScroll,
  GridVideoOverlay,
} from './ui'

const placeholder = getLegacyBpStaticPath('images/placeholder-image.png')

const PlayButton = styled(BasePlayButton)`
  height: 2.5rem;
  width: 2.5rem;
`

const StyledVideoOverlay = styled(VideoOverlay)`
  max-height: none;
`

export const MediaGrid = ({
  items,
  onSelect,
}: {
  items: KeyedMedia[]
  onSelect: (index: number) => void
}) => {
  const { formatMessage } = useIntl()
  const total = items.length

  return (
    <GridScroll>
      <Grid>
        {items.map((item, index) => {
          const isVideo = item.type === 'video'
          return (
            <GridCell
              key={item.key}
              aria-label={formatMessage(
                { id: 'Auction.details.enhancedGallery.thumbnailAriaLabel' },
                { index: index + 1, total }
              )}
              onClick={() => onSelect(index)}
            >
              <Image
                alt={
                  item.title ??
                  formatMessage(
                    { id: 'Auction.details.enhancedGallery.thumbnailAlt' },
                    { index: index + 1 }
                  )
                }
                fill
                loading="lazy"
                sizes="(max-width: 768px) 50vw, (max-width: 1100px) 33vw, 25vw"
                src={item.urls?.thumb ?? item.urls?.medium ?? placeholder}
                style={{ objectFit: 'cover' }}
              />
              {isVideo ? (
                <GridVideoOverlay>
                  <StyledVideoOverlay>
                    <PlayButton />
                  </StyledVideoOverlay>
                </GridVideoOverlay>
              ) : (
                <GridHoverOverlay aria-hidden />
              )}
            </GridCell>
          )
        })}
      </Grid>
    </GridScroll>
  )
}
